export default __webpack_public_path__ + "static/media/svg.c1f71d2d.svg";